import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-state_warn",
  "use": "icon-state_warn-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-state_warn\">\n<path d=\"M8 0C3.5816 0 0 3.5816 0 8C0 12.4184 3.5816 16 8 16C12.4184 16 16 12.4184 16 8C16 3.5816 12.4184 0 8 0ZM8 1.6C11.5344 1.6 14.4 4.4656 14.4 8C14.4 11.5344 11.5344 14.4 8 14.4C4.4656 14.4 1.6 11.5344 1.6 8C1.6 4.4656 4.4656 1.6 8 1.6ZM7.2 4V8.8H8.8V4H7.2ZM7.2 10.4V12H8.8V10.4H7.2Z\" fill=\"#FFA800\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol